module.exports = __webpack_public_path__ + "img/hdmi.024ddfad.png";